import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReviewHistoryV3Request } from './get-review-history-v3-request';
import type { IGetReviewHistoryV3Response } from './get-review-history-v3-response';
import { getReviewHistoryV3ResponseSchema } from './get-review-history-v3-response';

export async function getReviewHistoryV3Api(
  params?: IGetReviewHistoryV3Request,
): Promise<IValidatedResponse<IGetReviewHistoryV3Response>> {
  return getRequest<IGetReviewHistoryV3Response>({
    path: '/progress/v3/reviews',
    schema: getReviewHistoryV3ResponseSchema,
    options: {
      params: { cursor: params?.cursor, from: params?.from, to: params?.to },
    },
  });
}
